let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("dsYRV")]).then(() => parcelRequire('j9j0S'));